import { graphqlOperationWithTokenRefresh } from './graphqlOperation';

const mutation = /* GraphQL */ `
	mutation DeleteCoexistenceUISessionInfo($input: DeleteCoexistenceUISessionInfoInput!, $condition: ModelCoexistenceUISessionInfoConditionInput) {
		deleteCoexistenceUISessionInfo(input: $input, condition: $condition) {
			id
		}
	}
`;

/**
 * セッション情報削除APIを呼び出す
 */
export const mutationDeleteSessionInfo = async (authorizationToken: string) => {
	try {
		await graphqlOperationWithTokenRefresh(mutation, { input: { id: authorizationToken } }, authorizationToken);

		return;
	} catch (error: unknown) {
		console.error(error);

		return;
	}
};
